exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr{width:100%}.repleaceableTypeHeader{font-size:15px;display:flex;align-items:start;flex-direction:column;margin-top:15px;margin-bottom:5px;font-weight:500;color:blue;margin-left:30px}", ""]);

// exports
